import React, { useEffect, useState, useRef } from 'react';
import { getCookie, getUid } from '../../service/authCookie';
import { requestCanceller } from '../../service/axiosCancelToken';
import { checkVisit } from '../../service/checkVisit';
import { getUserOrders } from '../../service/order2Service';
import socket from '../../service/socket';
import LoadingSpinner from '../shared/LoadingSpinner';
import './Orders.css'
import InfiniteScroll  from 'react-infinite-scroll-component';
import LoadingBar from './../shared/LoadingBar';
import POrder from './POrder';

const POrders = () => {

    useEffect(()=> {
        socket.emit("viewMessage", {
            location: window.location.href,
            authenticated: getCookie(),
            UID : getCookie() ? getUid() : null
        }, (response) => {
            if(response && response.status === 'New')
            checkVisit(response.uId)
        });
    },[])
    
    const [mode, setMode] = useState('unconfirmed');
    const [orders, setOrders] = useState();
    const [isLoading, setIsLoading] = useState();
    const [lastItemId, setLastItemId] = useState('');
    const [hasMore, setHasMore] = useState(true);

    const ordersRef = useRef(null);
    const orderCountRef = useRef(null);
    const [countOfMode, setCountOfMode] = useState({
        unconfirmed: 0,
        processing: 0,
        delivered: 0
    });

    const changeModeHandler = (newMode) => {
        if(newMode === mode)
        return;
        ordersRef.current = null;
        setMode(newMode);
        setLastItemId('');
        setHasMore(true);
        setIsLoading(true);
    };

    useEffect(() => {
        if (orders && orderCountRef && orderCountRef.current <= orders.length) {
            setHasMore(false);
        }
    }, [orders, orderCountRef]);

    const fetchMoreData = async () => {
        const lastItemId = orders[orders.length - 1]._id;
        setLastItemId(lastItemId);
    };

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchAllOrders = async () => {
            try {
                let params = { id: lastItemId, mode: mode }
                let { status, data } = await getUserOrders(params, { cancelToken: cancelRequest.signal });
                if (status === 201) {
                    orderCountRef.current = data.counts;
                    setCountOfMode(data.allModesCount);
                    if (ordersRef.current) {
                        ordersRef.current = ordersRef.current.concat(data.orders);
                        setOrders(ordersRef.current);

                    }
                    else {
                        ordersRef.current = data.orders;
                        setOrders(ordersRef.current);
                    }
                    setIsLoading(false);
                }
            } catch (err) {

            }
        }
        fetchAllOrders();
        return () => {
            cancelRequest.cancel();
        }
    }, [lastItemId, mode]);
    
    return(
        <div className="orders">
            <div className="container">
                <div className='row'>
                    <div className="col-12">
                        <div className="orders-layer">
                            <h1 className="mb-4">سفارشات کالا</h1>
                            <ul>
                                <li>
                                    <a className={mode === 'unconfirmed' ? "activeItem": null} href="#news"
                                        onClick={() => changeModeHandler('unconfirmed')}
                                    >
                                        تایید نشده
                                    <span className="badge badge-light badge-pill ml-2">{countOfMode.unconfirmed}</span>
                                    </a>
                                </li>
                                <li>
                                    <a className={mode === 'processing' ? "activeItem": null} href="#news"
                                        onClick={() => changeModeHandler('processing')}
                                    >
                                        در حال انجام
                                    <span className="badge badge-light badge-pill ml-2">{countOfMode.processing}</span>
                                    </a>
                                </li>
                                <li>
                                    <a className={mode === 'delivered' ? "activeItem": null} href="#news"
                                        onClick={() => changeModeHandler('delivered')}
                                    >
                                    تحویل شده  
                                    <span className="badge badge-light badge-pill ml-2">{countOfMode.delivered}</span>
                                    </a>
                                </li>
                            </ul>
                            <div className="all-orders-body">
                                {
                                    (isLoading || !orders) ? 
                                    <div style={{ height: '70vh' }} className="d-flex">
                                        <div className="text-center align-self-center mx-auto">
                                            <LoadingSpinner />
                                        </div>
                                    </div>
                                    :
                                    <InfiniteScroll
                                    dataLength={orders && orders.length}
                                    next={fetchMoreData}
                                    hasMore={hasMore}
                                    loader={
                                        <div className="d-flex mt-2">
                                            <span className="mx-auto">
                                                <LoadingBar
                                                    type="spinningBubbles"
                                                    color="#0eac1b"
                                                />
                                            </span>
                                        </div>
                                    }
                                    endMessage={
                                        <p className="text-center mt-3">
                                        </p>
                                    }
                                >
                                    {
                                        orders.map((order, index) =>
                                            <POrder
                                                key={order._id}
                                                number={index + 1}
                                                factureNumber={order.buyNumber}
                                                fullName={order.facture.fullName}
                                                telephone={order.facture.telephone}
                                                address={order.facture.address}
                                                info={order.facture.info}
                                                totalPrice={order.facture.totalPrice}
                                                insertDate={order.insertDate}
                                                status={order.status}
                                                products={order.products}
                                                postPrice={order.postPrice}
                                                // deleteOrder={() => setDeleteId(order._id)}
                                            />
                                        )
                                    }
                                    </InfiniteScroll>
                                }
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default POrders;